import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MenuIcon from 'assets/icons/menu-icon.png'
import Menu from './Menu/Menu'
import styles from './header-bar.scss'

class HeaderBar extends Component {
  state = {
    isOpenMenu: false
  }
  renderLeftComponent = () => {
    const { left, menuIcon } = this.props

    if (left) {
      return left
    }

    if (menuIcon) {
      return (
        <img
          src={MenuIcon}
          width="18"
          className={styles['menu-icon']}
          onClick={() => this.setState({ isOpenMenu: true })}
        />
      )
    }
  }
  render() {
    const { isOpenMenu } = this.state
    const { right, children, width = 20 } = this.props

    return (
      <div className={styles['header-bar-container']}>
        <div className={styles['header-bar-nav']}>
          <div style={{ width }}>{this.renderLeftComponent()}</div>
          <div className={styles['header-title']}>{children}</div>
          <div style={{ width }}>{right}</div>
        </div>
        {isOpenMenu && <Menu onClose={() => this.setState({ isOpenMenu: false })} />}
      </div>
    )
  }
}

HeaderBar.propTypes = {
  left: PropTypes.any,
  right: PropTypes.any,
  children: PropTypes.element,
  width: PropTypes.number,
  menuIcon: PropTypes.bool
}

export default HeaderBar



// WEBPACK FOOTER //
// ./src/components/common/HeaderBar/HeaderBar.jsx